/**
 * Uzbek phone numbers: the backend wants "998" + 9 digits in any punctuation,
 * the UI always shows "+998 90 123-45-67" (docs/frontend/README.md).
 */
export const PHONE_PREFIX = '998'
export const PHONE_LENGTH = 12

/** Keeps digits only: "+998 90 123-45-67" → "998901234567". */
export function normalizePhone(input: string): string {
  return input.replace(/\D+/g, '')
}

export function isValidPhone(input: string): boolean {
  const digits = normalizePhone(input)
  return digits.length === PHONE_LENGTH && digits.startsWith(PHONE_PREFIX)
}

/** Display format. Invalid input is returned untouched so the user can fix it. */
export function formatPhone(input: string): string {
  const d = normalizePhone(input)
  if (!isValidPhone(d)) return input
  return `+${d.slice(0, 3)} ${d.slice(3, 5)} ${d.slice(5, 8)}-${d.slice(8, 10)}-${d.slice(10, 12)}`
}

/** For logs and support screens — phones are PII (07-logging §no PII). */
export function maskPhone(input: string): string {
  const d = normalizePhone(input)
  if (!isValidPhone(d)) return '***'
  return `+${d.slice(0, 3)} ${d.slice(3, 5)} ***-**-${d.slice(10, 12)}`
}
